<template>
  <div class="download ">
    <banner :img="require('../assets/img/bgtop5.jpg')" title="" />
    <div class="ContactUs">
      

    
      <div class="ModuleItem  StaticModule  " wo="327" id="module_414347509">
        <p style="color: rgb(106, 106, 106); font-size: 16px; line-height: 1.333; font-weight: bold; ">&nbsp;</p>
        
        <p style="color: rgb(106, 106, 106); font-size: 32px; line-height: 1.333; font-weight: bold; "><span style="color:#000000;"><span style="line-height:1;">
          <span style="font-size:32px;">苏州中柳工程服务有限公司</span></span></span>
        </p>
        
        <p style="font-weight: normal; color: rgb(153, 153, 153); padding: 10px 0px 17px; font-size: 12px; ">
          <span style="line-height:1;">Suzhou Zhongliu Engineering Service Co., Ltd</span></p>
        </div>
        
        <div style="color:#6a6a6a;font-size: 12px;line-height: 1.846;;border:0">
        <p style="padding-bottom: 5px; "><span style="font-size:16px;"><span style="color:#696969;">总部地址</span>：昆山市玉山镇中山路138号中茵写字楼1009</span></p>
          
          <p style="padding-bottom: 5px; "><span style="font-size:16px;"><span style="color:#696969;">公司电话：</span>0521一57255637</span></p>
          
          <p style=""><span style="font-size:16px;"><span style="color:#696969;">电子邮箱：</span>459821273@qq. com</span></p>
          
          <p style=""><span style="font-size:16px;"><span style="color:#696969;">官方网站：</span>https://www.szzldb.com</span></p>
          
          <p style="">&nbsp;</p>
        </div>
        <div class="ContactUs_content">
          <h3 style="font-size:32px;">联系我们</h3>
          <p style="font-weight: normal; color: rgb(153, 153, 153); padding: 10px 0px 17px; font-size: 12px; ">
            <span style="line-height:1;">Suzhou Zhongliu Engineering Service Co., Ltd</span>
          </p>
          <ul>
            <li>
              <img src="../assets/img/ContactUs1.png" alt="">
              <p>业务咨询</p>
              <p>0521一57255637 / 13823202567</p>
            </li>
            <li>
              <img src="../assets/img/ContactUs2.png" alt="">
              <p>在线咨询</p>
              <p>点击图标，与销售顾问进行在线沟通</p>
            </li>
            <li>
              <img src="../assets/img/ContactUs3.png" alt="">
              <p>扫描二维码
  
              </p>
              <p>与销售顾问咨询
  
              </p>
              <img class="rightImg" src="../assets/img/ercode.jpg" alt="">
            </li>
            <li>
              <img src="../assets/img/ContactUs4.png" alt="">
              <p>非工作时间咨询</p>
              <p>13823202567</p>
            </li>
            <li>
              <img src="../assets/img/ContactUs5.png" alt="">
              <p>业务咨询邮件</p>
              <p>459821273@qq.com</p>
            </li>
            <li>
              <img src="../assets/img/ContactUs6.png" alt="">
              <p>周一到周五</p>
              <p>09:00-18:00</p>
            </li>
          </ul>
  
        </div>
        <div class="ContactUs_content ContactUs_content2">
          <h3 style="font-size:32px;">人才招聘</h3>
          <p style="font-weight: normal; color: rgb(153, 153, 153); padding: 10px 0px 17px; font-size: 12px; ">
            <span style="line-height:1;">RECRUIT</span>
          </p>
          <p style="text-align: center;">面向社会公开招聘，请符合条件的应聘者发送简历电子版至 459821273@qq. com ，电子邮件标题请注明“应聘岗位+姓名”。公司将通过电话或电子邮件方式通知面试，未通过简历筛选者不再另行通知。</p>
          <div class="BodyCenter BodyCenter414351563 clearfix"><div class="imageTextGiant-Container imageTextContainer clearfix" show_more="显示更多" hasresponsive="1" autohideype="0" autohide="0" hideheight="150" hidewidth="760">
            <div class="ModuleImageTextGiantContent ModuleImageTextContent">
              <p style="line-height: 1.75em;">&nbsp;</p>
          
          <p style="text-align: center;"><span style="font-size: 20px; color: rgb(243, 21, 21);">客户经理&nbsp;</span>General Manager</p>
          
          <p style="text-align: center;"><span style="color: rgb(127, 127, 127); text-align: center;">（</span><span style="color: rgb(127, 127, 127); text-align: center;">110人职位</span><span style="color: rgb(127, 127, 127); text-align: center;">）</span></p>
          
          <p style="text-align: center;">&nbsp;</p>
          
          <hr>
          <p style="line-height: 1.75em;">&nbsp;</p>
          
          <p style="line-height: 1.75em;"><span style="line-height:1.75;"><span style="color:#000000;"><strong><span style="background-color: rgb(255, 255, 255);">岗位职责</span></strong></span></span></p>
          
          <p>&nbsp;</p>
          
          <p><span style="line-height:1.75;"><span style="color: rgb(89, 89, 89);">薪酬:固定工资+绩效工资+提成+季度/年度业绩奖金，综合8k一20K<br>
          地址:</span><span style="color:#000000;"><span style="font-size:16px;">昆山市玉山镇中山路138号中茵写字楼1009</span></span><br>
          <span style="color: rgb(89, 89, 89);">派驻区域:深圳、广州、成都、重庆、武汉、上海、 杭州、苏州、郑州←将根据应聘者所在城市进行分配。</span></span></p>
          
          <p>&nbsp;</p>
          
          <p><span style="line-height:1.75;"><strong><span style="color:#000000;">任职要求</span></strong></span></p>
          
          <p>&nbsp;</p>
          
          <p><span style="line-height:1.75;"><span style="color:#696969;">1、21一35岁，男女不限，大专及以上学历，同行业优秀客户经理可放宽年龄要求；<br>
          2、 熟悉建筑工程领域，有客服、电销、金融、建筑工程担保等工作经验者优先；<br>
          3、有激情、有自信，沟通能力强，具备良好的客户开发及服务意识；<br>
          4、欢迎有工程担保、建筑行业资源的人才加入！</span></span></p>
          
          <p>&nbsp;</p>
          
          <p><span style="line-height:1.75;"><strong><span style="color:#000000;">岗位职责</span></strong></span></p>
          
          <p>&nbsp;</p>
          
          <p style="line-height: 1.5em;"><span style="color:#696969;"><span style="line-height:1.75;">1、通过网络、电话、陌生拜访、预约拜访等多种营销方式开发客户；<br>
          2、负责拓展新的渠道，不断开发新客户，维护老客户；&nbsp;<br>
          3、收集和分析市场数据，并定期反馈最新信息；<br>
          4、认真落实公司领导安排的其他任务。</span></span></p>
          
          <p style="line-height: 1.5em;">&nbsp;</p>
          
          <p><span style="line-height:1.75;"><strong><span style="color:#000000;">福利待遇</span></strong></span></p>
          
          <p style="line-height: 1.5em;"><br>
          <span style="color:#696969;"><span style="line-height:1.75;">1、5天工作制，每天上班7.5小时，周末双休；享受国家规定的法定节假日，及各类带薪假期；入职提供五险一金。&nbsp;<br>
          2、员工旅游及各种团建、生日会等；<br>
          3、每年享受公司免费提供团体体检；<br>
          4、公司实行“专业方向”与“管理方向”的岗位晋升机制；</span></span></p>
          
          <p style="line-height: 1.5em;"><br>
          <span style="line-height:1.75;"><span style="font-size:14px;"><strong>专业方向 :&nbsp;&nbsp;</strong><span style="color:#696969;">初级客户经理一中级客户经理一高级客户经理一资深客户经理；</span></span></span></p>
          
          <p style="line-height: 1.5em;"><span style="line-height:1.75;"><span style="font-size:14px;"><strong>管理方向 :&nbsp;&nbsp;</strong><span style="color:#696969;">客户经理一业务主管一区域经理。&nbsp;</span></span></span></p>
          
          <p style="line-height: 1.5em;">&nbsp;</p>
          
          <p style="line-height: 1.5em;"><span style="line-height:1.75;"><span style="font-size:14px;"><span style="color:#696969;">
            <img  src="../assets/img/zhaopin.jpg"  style="width: 1000px; height: 592px; background: none;" delay-inited="true">
              </span></span>
            </span>
          </p>
          
          <p style="line-height: 1.5em;">&nbsp;</p>
          
            </div>
          </div>
          </div>
        </div>
    </div>
</div>
      
      
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
h3{
  color: #000000; font-size: 32px;
}
.ContactUs_content{
  overflow: hidden;
  margin-top: 60px;
  margin-bottom: 60px;
  li{
    list-style-type: none;
    background-color: rgb(242, 242, 242);
    width:390px;
    height: 190px;
    float: left;
    margin: 6px;
    box-sizing: border-box;
    padding: 40px;
    position: relative;
    img{
      width: 52px;
      height: 52px;
      margin-bottom: 20px;
    }
  }
}
.ContactUs{
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
}
.rightImg{
  position: absolute;
  right: 40px;
  top: 40px;
  height: 120px!important;
  width: 120px!important;
}
</style>